import React, { Component } from "react";
import Product from "./Product";
import Title from "./Title";

import styled from "styled-components";
import { ProductConsumer } from "../context";
import firebase from "./Fireb"
import { firestore } from "firebase";
//import { storeProducts } from "../data";

export default class ProductList extends Component {
 state = {
    products: [],
    vendor: [],
    check: false
  };
  
  componentDidMount() {

    const ref = firebase.firestore().collection('storeProducts');//.where("vid", "==", "BeC9b7iZaONSXAyd1EpOvqcPur53");
      ref.get().then((querySnapshot => {

   //    const data = querySnapshot.docs.map(doc => doc.data());

      const data = querySnapshot.docs.map(doc => ({...doc.data(), id: doc.id}));

      const ref1 = firebase.firestore().collection('record').doc(firebase.auth().currentUser.uid);
      ref1.get().then((doc) => {
        if (doc.exists) {
          this.setState({
            vendor: doc.data(),
            key1: doc.id,
            isLoading: false
          });
        } else {
          console.log("No such document!");
        }
      });
      const ref2 = firebase.firestore().collection('storeProducts').where("vid", "==", firebase.auth().currentUser.uid);
      ref2.get().then((querySnapshot => {
        querySnapshot.forEach((doc) => {
        if (doc.exists) {
          this.setState({
            check: true
          })
        } else {
          this.setState({
            check: false
          })
        }
      });
    }))
    
   



   



    this.setState(
      {
        products: data ,
       
     
  });
  

}));
  }
  
  rendercheck() {
  
if(this.state.vendor.student == false) {
  if(this.state.check == true)
    return (
      <React.Fragment>
        <ProductWrapper className="py-5">
          <div className="container">
            <Title name="Avilable" title="products" />
            <div className="row">
              <ProductConsumer>
                {value => {
                  return value.products.map(product => {
                    return <Product key={product.id} product={product} />;
                  });
                }}
              </ProductConsumer>
            </div>
          </div>
        </ProductWrapper>
      </React.Fragment>
    );
              }
  }
  rendercheck1() {
  
    if(this.state.vendor.student == false) {
      if(this.state.check == false)
        return (
          <React.Fragment>
            <ProductWrapper className="py-5">
              <div className="container">
                <Title name="No availaible" title="products" />
                <div className="row">
                  <ProductConsumer>
                    {value => {
                      return value.products.map(product => {
                        return <Product key={product.id} product={product} />;
                      });
                    }}
                  </ProductConsumer>
                </div>
              </div>
            </ProductWrapper>
          </React.Fragment>
        );
                  }
      }
  rendercheck2()
{ 

  if(this.state.vendor.student == true) 
  {
 
  return(
    <div className="container">
    <Title name="You don't have permission" title="to access the POS" />
    </div>
  )}

}
render() {

  return (
   <div>
  {this.rendercheck()}
  {this.rendercheck1()}
  
  {this.rendercheck2()}
  
      </div>
  )
}
}

const ProductWrapper = styled.section``;